// import React, { useState } from 'react'

// export default function CustomStepper({ Data, showOnlyValue = false }) {
//     console.log("Data",Data)
//     const [showHovered, setShowHovered] = useState(null)
//     return (
//         <>
//             <div className='StepperOption' style={{ marginTop: '30px' }}>
//                 {
//                     Data?.length > 0 ? Data?.map((val, id) => {
//                         const isFirst = id === 0;
//                         const isLast = id === Data.length - 1;
//                         const isHovered = showHovered?.name === val?.name;

//                         return (
//                             <>
//                                 <div className='main-single-content'>
//                                     <div className={`boxed ${val?.yellowBox ? "yellowBox" : ""}`}
//                                         onMouseEnter={() => setShowHovered(val)}
//                                         onMouseLeave={() => setShowHovered(null)}
//                                     >
//                                         {
//                                             showOnlyValue ?
//                                                 <h6 style={{ fontSize: '16px' }}>{val?.value}</h6>
//                                                 :
//                                                 <h6>{val?.value} <br /> {val?.subValue}</h6>
//                                         }
//                                     </div>
//                                     <h5>{val?.name?.split(" ").map((word, index) => (
//                                         <React.Fragment key={index}>
//                                             {word}
//                                             {index === 0 && <br />}
//                                             {index !== 0 && " "}
//                                         </React.Fragment>
//                                     ))}</h5>

//                                     {isHovered && val?.dropOffPercentage != null && (
//                                         <div className={`mouseHoverSection ${isFirst ? 'first' : ''} ${isLast ? 'last' : ''}`}>
//                                             <h6>Drop Off :</h6>
//                                             <h6 style={{ fontWeight: 600, marginTop: '4px' }}>
//                                                 {val.dropOffPercentage.toFixed(2)}%
//                                             </h6>
//                                         </div>
//                                     )}

//                                 </div>
//                             </>
//                         )
//                     })
//                         : ""}
//             </div>
//         </>
//     )
// }

import React, { useState } from 'react'
import { getDropOfListLeadByFilters } from '../ActionCreator'
import moment from 'moment'

const SIZE = 10;

export default function CustomStepper({ Data, showOnlyValue = false, dateFilterPopup }) {
    const [showHovered, setShowHovered] = useState(null)
    const [popupData, setPopupData] = useState(null)
    const [popupMeta, setPopupMeta] = useState(null)
    const [popupLoading, setPopupLoading] = useState(false)
    const [currentPage, setCurrentPage] = useState(0)
    const [total, setTotal] = useState(0)

    const fetchPopupData = (val, page) => {
        setPopupLoading(true)
        getDropOfListLeadByFilters(
            val?.name,
            moment(dateFilterPopup?.from).format("DD-MM-YYYY"),
            moment(dateFilterPopup?.to).format("DD-MM-YYYY"),
            page,
            SIZE,
            (callback) => {
                setPopupData(callback?.data?.leadList ?? [])
                setTotal(callback?.data?.dropOffCount ?? 0)
                setPopupLoading(false)
            }
        )
    }

    const handleBoxClick = (val) => {
        if (val?.yellowBox) return
        setPopupMeta(val)
        setPopupData(null)
        setCurrentPage(0)
        setTotal(0)
        fetchPopupData(val, 0)
    }

    const handlePageChange = (newPage) => {
        setCurrentPage(newPage)
        fetchPopupData(popupMeta, newPage)
    }

    const closePopup = () => {
        setPopupMeta(null)
        setPopupData(null)
        setPopupLoading(false)
        setCurrentPage(0)
        setTotal(0)
    }

    const totalPages = Math.ceil(total / SIZE)

    const getPaginationPages = (current, total) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i)
        if (current <= 3) return [0, 1, 2, 3, 4, '...', total - 1]
        if (current >= total - 4) return [0, '...', total - 5, total - 4, total - 3, total - 2, total - 1]
        return [0, '...', current - 1, current, current + 1, '...', total - 1]
    }

    return (
        <>
            <div className='StepperOption' style={{ marginTop: '30px' }}>
                {Data?.length > 0 ? Data?.map((val, id) => {
                    const isFirst = id === 0
                    const isLast = id === Data.length - 1
                    const isHovered = showHovered?.name === val?.name

                    return (
                        <div className='main-single-content' key={val?.name || id}>
                            <div
                                className={`boxed ${val?.yellowBox ? "yellowBox" : ""}`}
                                onMouseEnter={() => setShowHovered(val)}
                                onMouseLeave={() => setShowHovered(null)}
                                onClick={() => handleBoxClick(val)}
                                style={{ cursor: val?.yellowBox ? 'default' : 'pointer' }}
                            >
                                {showOnlyValue ?
                                    <h6 style={{ fontSize: '16px' }}>{val?.value}</h6>
                                    :
                                    <h6>{val?.value} <br /> {val?.subValue}</h6>
                                }
                            </div>

                            <h5>{val?.name?.split(" ").map((word, index) => (
                                <React.Fragment key={index}>
                                    {word}
                                    {index === 0 && <br />}
                                    {index !== 0 && " "}
                                </React.Fragment>
                            ))}</h5>

                            {/* {isHovered && val?.dropOffPercentage != null && (
                                <div className={`mouseHoverSection ${isFirst ? 'first' : ''} ${isLast ? 'last' : ''}`}>
                                    <h6>Drop Off :</h6>
                                    <h6 style={{ fontWeight: 600, marginTop: '4px' }}>
                                        {typeof val.dropOffPercentage === 'number'
                                            ? val.dropOffPercentage.toFixed(2)
                                            : val.dropOffPercentage}%
                                    </h6>
                                </div>
                            )} */}
                        </div>
                    )
                }) : ""}
            </div>

            {/* Popup Modal */}
            {popupMeta && (
                <div
                    style={{
                        position: 'fixed', inset: 0,
                        backgroundColor: 'rgba(0,0,0,0.45)',
                        zIndex: 1000,
                        display: 'flex', alignItems: 'center', justifyContent: 'center'
                    }}
                    onClick={closePopup}
                >
                    <div
                        style={{
                            background: '#fff',
                            borderRadius: '12px',
                            padding: '28px',
                            minWidth: '700px',
                            maxWidth: '90vw',
                            maxHeight: '85vh',
                            display: 'flex',
                            flexDirection: 'column',
                            boxShadow: '0 8px 32px rgba(0,0,0,0.18)'
                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Header */}
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                            <div>
                                <h4 style={{ margin: 0, fontSize: '18px', fontWeight: 700 }}>{popupMeta?.name}</h4>
                                <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#94a3b8' }}>
                                    {total} total drop-off user{total !== 1 ? 's' : ''}
                                </p>
                            </div>
                            <span
                                onClick={closePopup}
                                style={{ cursor: 'pointer', fontSize: '20px', color: '#888', lineHeight: 1 }}
                            >✕</span>
                        </div>

                        {/* Drop Off Stats Cards */}
                        <div style={{ display: 'flex', gap: '16px', marginBottom: '24px' }}>
                            <div style={{
                                flex: 1, background: '#fff8e1', border: '1px solid #ffe082',
                                borderRadius: '8px', padding: '16px', textAlign: 'center'
                            }}>
                                <p style={{ margin: 0, fontSize: '12px', color: '#888', marginBottom: '6px' }}>Current Drop Off</p>
                                <h3 style={{ margin: 0, fontSize: '24px', fontWeight: 700, color: '#f59e0b' }}>
                                    {typeof popupMeta?.dropOffPercentage === 'number'
                                        ? `${popupMeta.dropOffPercentage.toFixed(2)}%`
                                        : popupMeta?.dropOffPercentage ?? '-'}
                                </h3>
                            </div>
                            <div style={{
                                flex: 1, background: '#f0f4ff', border: '1px solid #c7d2fe',
                                borderRadius: '8px', padding: '16px', textAlign: 'center'
                            }}>
                                <p style={{ margin: 0, fontSize: '12px', color: '#888', marginBottom: '6px' }}>Previous Drop Off</p>
                                <h3 style={{ margin: 0, fontSize: '24px', fontWeight: 700, color: '#6366f1' }}>
                                    {typeof popupMeta?.prevDropOffPercentage === 'number'
                                        ? `${popupMeta.prevDropOffPercentage.toFixed(2)}%`
                                        : popupMeta?.prevDropOffPercentage ?? '-'}
                                </h3>
                            </div>
                            {typeof popupMeta?.dropOffPercentage === 'number' &&
                                typeof popupMeta?.prevDropOffPercentage === 'number' && (
                                    <div style={{
                                        flex: 1,
                                        background: (popupMeta.dropOffPercentage - popupMeta.prevDropOffPercentage) > 0 ? '#fff1f2' : '#f0fdf4',
                                        border: `1px solid ${(popupMeta.dropOffPercentage - popupMeta.prevDropOffPercentage) > 0 ? '#fecdd3' : '#bbf7d0'}`,
                                        borderRadius: '8px', padding: '16px', textAlign: 'center'
                                    }}>
                                        <p style={{ margin: 0, fontSize: '12px', color: '#888', marginBottom: '6px' }}>Change</p>
                                        <h3 style={{
                                            margin: 0, fontSize: '24px', fontWeight: 700,
                                            color: (popupMeta.dropOffPercentage - popupMeta.prevDropOffPercentage) > 0 ? '#ef4444' : '#22c55e'
                                        }}>
                                            {(popupMeta.dropOffPercentage - popupMeta.prevDropOffPercentage) > 0 ? '▲' : '▼'}
                                            {Math.abs(popupMeta.dropOffPercentage - popupMeta.prevDropOffPercentage).toFixed(2)}%
                                        </h3>
                                    </div>
                                )}
                        </div>

                        {/* Table — scrollable middle section */}
                        <div style={{ flex: 1, overflowY: 'auto', overflowX: 'auto' }}>
                            {popupLoading ? (
                                <div style={{ textAlign: 'center', padding: '40px 0', color: '#888' }}>Loading users...</div>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 1 }}>
                                        <tr style={{ background: '#f8fafc' }}>
                                            {['#', 'Full Name', 'Mobile Number', 'Form Status', 'Login Date', 'Completion Date', 'Create Date'].map((h) => (
                                                <th key={h} style={{
                                                    padding: '10px 12px', textAlign: 'left',
                                                    borderBottom: '2px solid #e2e8f0',
                                                    fontWeight: 600, color: '#475569',
                                                    whiteSpace: 'nowrap'
                                                }}>{h}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {popupData?.length > 0 ? popupData.map((row, idx) => (
                                            <tr
                                                key={row?.userId || idx}
                                                style={{ borderBottom: '1px solid #f1f5f9' }}
                                                onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                                                onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                                            >
                                                {/* Serial number is global across pages */}
                                                <td style={{ padding: '10px 12px', color: '#94a3b8' }}>
                                                    {currentPage * SIZE + idx + 1}
                                                </td>
                                                <td style={{ padding: '10px 12px', fontWeight: 500 }}>{row?.fullName ?? '-'}</td>
                                                <td style={{ padding: '10px 12px' }}>{row?.mobileNumber ?? '-'}</td>
                                                <td style={{ padding: '10px 12px' }}>
                                                    <span style={{
                                                        padding: '2px 10px', borderRadius: '20px', fontSize: '11px', fontWeight: 600,
                                                        background: row?.formStatus === 'NotApproved' ? '#fff1f2' : '#f0fdf4',
                                                        color: row?.formStatus === 'NotApproved' ? '#ef4444' : '#22c55e'
                                                    }}>
                                                        {row?.formStatus ?? '-'}
                                                    </span>
                                                </td>
                                                <td style={{ padding: '10px 12px' }}>{row?.loginDate ?? '-'}</td>
                                                <td style={{ padding: '10px 12px' }}>{row?.formCompletionDate ?? '-'}</td>
                                                <td style={{ padding: '10px 12px' }}>{row?.createDate ?? '-'}</td>
                                            </tr>
                                        )) : (
                                            <tr>
                                                <td colSpan={7} style={{ textAlign: 'center', padding: '32px', color: '#94a3b8' }}>
                                                    No data available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>

                        {/* Pagination — pinned to bottom */}
                        {totalPages > 1 && (
                            <div style={{
                                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                                paddingTop: '16px', marginTop: '8px',
                                borderTop: '1px solid #f1f5f9',
                                flexShrink: 0
                            }}>
                                {/* Left: showing count */}
                                <p style={{ margin: 0, fontSize: '12px', color: '#94a3b8' }}>
                                    Showing {currentPage * SIZE + 1}–{Math.min((currentPage + 1) * SIZE, total)} of {total}
                                </p>

                                {/* Center: page buttons */}
                                <div style={{ display: 'flex', gap: '4px', alignItems: 'center' }}>
                                    {/* Prev */}
                                    <button
                                        onClick={() => handlePageChange(currentPage - 1)}
                                        disabled={currentPage === 0 || popupLoading}
                                        style={{
                                            padding: '6px 10px', borderRadius: '6px', border: '1px solid #e2e8f0',
                                            background: currentPage === 0 ? '#f8fafc' : '#fff',
                                            color: currentPage === 0 ? '#cbd5e1' : '#475569',
                                            cursor: currentPage === 0 ? 'not-allowed' : 'pointer',
                                            fontSize: '13px'
                                        }}
                                    >‹ Prev</button>

                                    {/* Page numbers */}
                                    {getPaginationPages(currentPage, totalPages).map((page, i) =>
                                        page === '...' ? (
                                            <span key={`ellipsis-${i}`} style={{ padding: '0 4px', color: '#94a3b8' }}>…</span>
                                        ) : (
                                            <button
                                                key={page}
                                                onClick={() => handlePageChange(page)}
                                                disabled={popupLoading}
                                                style={{
                                                    padding: '6px 10px', borderRadius: '6px',
                                                    border: page === currentPage ? 'none' : '1px solid #e2e8f0',
                                                    background: page === currentPage ? '#6366f1' : '#fff',
                                                    color: page === currentPage ? '#fff' : '#475569',
                                                    cursor: 'pointer', fontSize: '13px',
                                                    fontWeight: page === currentPage ? 600 : 400,
                                                    minWidth: '32px'
                                                }}
                                            >{page + 1}</button>
                                        )
                                    )}

                                    {/* Next */}
                                    <button
                                        onClick={() => handlePageChange(currentPage + 1)}
                                        disabled={currentPage >= totalPages - 1 || popupLoading}
                                        style={{
                                            padding: '6px 10px', borderRadius: '6px', border: '1px solid #e2e8f0',
                                            background: currentPage >= totalPages - 1 ? '#f8fafc' : '#fff',
                                            color: currentPage >= totalPages - 1 ? '#cbd5e1' : '#475569',
                                            cursor: currentPage >= totalPages - 1 ? 'not-allowed' : 'pointer',
                                            fontSize: '13px'
                                        }}
                                    >Next ›</button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    )
}